import React from "react";
import { Breadcrumbs, Typography, Link, Box, Container } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

export default function BreadcrumbsComponent() {
  const navigate = useNavigate();
  const location = useLocation();

  const pathnames = location.pathname
    .split("/")
    .filter((x) => x && isNaN(x) && x[0] === x[0].toLowerCase())
    .slice(1);

  const handleBreadcrumbClick = (index) => {
    const to = `/admin` + `/${pathnames.slice(0, index + 1).join("/")}`;
    navigate(to);
  };

  return (
    <>
      <Box
        component="section"
        id="breadcrumbs"
        sx={{ p: 0, backgroundColor: "#fff" }}
        className="container_main"
      >
        <Container maxWidth="xl" className="container">
          <div role="presentation">
            <Breadcrumbs
              className="breadcrumb"
              separator="/"
              aria-label="breadcrumb"
            >
              {pathnames.map((value, index) => {
                const last = index === pathnames.length - 1;
                const to =
                  `admin` + `/${pathnames.slice(0, index + 1).join("/")}`;

                return last ? (
                  <Typography key={to} color="text.primary">
                    {value.charAt(0).toUpperCase() +
                      value.slice(1).replace(/-/g, " ")}
                  </Typography>
                ) : (
                  <Link
                    underline="hover"
                    color="inherit"
                    component="div"
                    key={to}
                    sx={{ cursor: "pointer" }}
                    onClick={() => handleBreadcrumbClick(index)}
                  >
                    {value.charAt(0).toUpperCase() +
                      value.slice(1).replace(/-/g, " ")}
                  </Link>
                );
              })}
            </Breadcrumbs>
          </div>
        </Container>
      </Box>
    </>
  );
}
